import React from 'react';
import { Link } from 'react-router-dom';

const Writing = () => {
    return (
        <div style={{ overflowY: "hidden", width: "100%", height: "100%" }}>
            <iframe width="100%" height="100%"
                src="https://datastudio.google.com/embed/reporting/734d7fd3-69c6-4661-9061-717ba115c3b2/page/p_ehtgiioxsc"
                frameBorder="0" allowFullScreen>
            </iframe>
        </div>
    );
}

export default Writing;